<template>
    <div class="pc-header-container">
        <div class="header-top">
            <div class="header-main-box mq-flex-between-center">
                <div class="logo-box mq-flex-center">
                    <img src="https://cdn.bigbays.cn/home/cangqiong-logo.png" alt="">
                    <span>苍穹云系统</span>
                    <span class="txt1">产业链信息化服务商</span>
                </div>
                <div class="search-box">
                    <div class="search-input">
                        <input type="text" v-model="searchValue">
                        <div class="search-btn" @click="goSearch()">搜索</div>
                    </div>
                </div>
                <div class="login-signin-btns" v-if="isLogin">
                    <div class="btn login" @click="goLogin()">登录</div>
                    <div class="btn signin" @click="goSignin()">注册</div>
                </div>
                <el-dropdown trigger="click" @visible-change="handeleDropdownChange" @command="handleCommandClick" v-else>
                    <div class="user-menu-box mq-flex-center">
                        <el-avatar :size="26" :src="$store.state.defaultAvatar"></el-avatar>
                        <p class="username mq-ellipsis-line1" title="">这是用户名啊啊啊</p>
                        <i class="el-icon-arrow-down el-icon--right" :class="{isopen: userDropOpen}"></i>
                    </div>
                    <el-dropdown-menu class="userdropdown" slot="dropdown">
                        <el-dropdown-item command="userAccountCenterP">账户中心</el-dropdown-item>
                        <el-dropdown-item command="userCostCenterP">费用中心</el-dropdown-item>
                        <el-dropdown-item command="userMyorderP">我的订单</el-dropdown-item>
                        <el-dropdown-item command="userMycourseP">我的课程</el-dropdown-item>
                        <el-dropdown-item command="userServiceManageP">服务商管理</el-dropdown-item>
                        <el-dropdown-item command="logout" divided>安全退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="header-bottom">
            <div class="header-main-box">
                <ul class="nav-list">
                    <li class="nav-item" v-for="(item, i) in navList" :key="i"
                        :class="{active:navIndex==i||navHoverIndex==i}" @mouseenter="handleNavEnter(i)" 
                        @mouseleave="handleNavLeave()" @click="handleNavClick(i)">
                        <p class="mq-flex-center-center">
                            <span>{{item.name}}</span>
                            <i class="el-icon-arrow-down" v-show="i>2&&i<7"></i>
                        </p>
                        <!-- 政策扶持下拉菜单 -->
                        <div class="policy-menu-box" v-if="item.id == 7">
                            <div class="policy-item" v-for="(pol, p) in item.children" :key="p">{{pol.name}}</div>
                        </div>
                    </li>
                </ul>
                <!-- 下拉菜单 -->
                <div class="pulldown-menu-box" id="pullDownMenu" :class="{h100: pullDownMenuShow}">
                    <div class="search-box">
                        <input type="text" placeholder="搜索">
                        <i class="el-icon-search" @click="searchResultShow=!searchResultShow"></i>
                        <div class="search-result-box" :class="{show:searchResultShow}">
                            <ul class="result-list">
                                <li v-for="n in 10" :key="n">搜索结果</li>
                            </ul>
                        </div>
                    </div>
                    <div class="menu-main-box">
                        <div class="left-menu-box">
                            <ul class="left-menu-list">
                                <li class="menu-item" v-for="(item, i) in leftMenuList" :key="i" 
                                    :class="{active:i == leftMenuIndex}">
                                    <p @click="handleLeftMenuClick(i)">{{item.name}}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="right-menu-box">
                            <div class="item-list-view" v-for="(item, i) in rightMenuList" :key="i" :class="{mrnone:i%4==3}">
                                <p class="item-title" @click="handleRightMenuClick(i, -1)">{{item.name}}</p>
                                <ul class="item-menu-list">
                                    <li v-for="(temp, j) in item.son" :key="j" @click="handleRightMenuClick(i, j)">{{temp.name}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'pcHeader',
    data() {
        return {
            searchValue: '', // 搜索值
            isLogin: false, // 是否登录
            navList: [], // 导航列表
            navIndex: 0, // 导航选中项
            navHoverIndex: -1, // 菜单项的激活状态
            historyHoverIndex: 0, // 下拉菜单历史激活项
            pullDownMenuShow: false, // 下拉菜单显示控制
            pullDownMenuEnter: false, // 鼠标是否进入下拉菜单区域
            searchResultShow: false, // 下拉菜单区搜索结果列表显示控制
            leftMenuList: [], // 下拉菜单左侧菜单列表
            leftMenuIndex: 0, // 下拉菜单左侧菜单选中项
            rightMenuList: [], // 下拉菜单右侧菜单列表
            userDetail: {}, // 用户详情
            userDropOpen: false, // 用户下拉菜单展开
        }
    },
    created() {
        this.isLogin = !window.localStorage.getItem('token');
        this.getNavList();
        this.openBus();
        this.getUserData();
    },
    methods: {
        /**
         * @function getPageParams 获取页面参数
         */
        getPageParams() {
            let data = window.sessionStorage.getItem('pcHeader');
            if(data) {
                let _data = JSON.parse(data), i = Number(_data.nav_index);
                this.navIndex = i;
                this.$store.commit('setPageModuleList', this.navList[i].children);
            } else {
                // this.handleNavClick(0);
                this.navIndex = 0;
                this.$store.commit('setPageModuleList', this.navList[0].children);
            }
        },
        /**
         * @function getNavList 获取导航列表
         */
        getNavList() {
            this.$axios.get(this.$urls.columnList, {
                params: {
                    from: 'frontend'
                }
            }).then(res => {
                // console.log(res);
                let data = res.result;
                this.navList = data;
                this.$store.commit('setColumnList', data);
                this.getPageParams();
            });
        },
        openBus() {
            this.$bus.$on('navActive', res => {
                console.log(res);
                this.navIndex = Number(res);
                if(this.navList.length > 0) {
                    this.$store.commit('setPageModuleList', this.navList[Number(res)].children);
                }
                this.setPageParams();
            });
            this.$bus.$on('getUserData', (res) => {
                this.isLogin = !window.localStorage.getItem('token');
                this.getUserData();
            });
        },
        /**
         * @function getUserData 获取用户信息
         */
        getUserData() {
            if(window.localStorage.getItem('token')) {
                this.$axios.get(this.$urls.userDetail).then(res => {
                    console.log('userDetail>>>', res);
                    this.userDetail = res.result;
                    this.$store.commit('setUserDetail', this.userDetail);
                });
            }
        },
        /**
         * @function handeleDropdownChange 用户下拉菜单展开/收起
         */
        handeleDropdownChange(val) {
            this.userDropOpen = val;
        },
        /**
         * @function handleCommandClick 用户下拉菜单选择
         */
        handleCommandClick(com) {
            console.log(com);
            switch (com) {
                case 'logout': // 退出登录
                    this.logOut();
                    break;
                default:
                    break;
            }
        },
        /**
         * @function logOut 退出登录
         */
        logOut() {
            window.localStorage.setItem('token', '');
            this.isLogin = true; // 显示登录注册按钮
            this.userDetail = {};
            this.$store.commit('setUserDetail', {});
        },
        /**
         * @function goSearch 去搜索
         */
        goSearch() {
            this.$router.push({ path: '/searchP', query: { keyword: this.searchValue } });
            this.searchValue = '';
        },
        /**
         * @function goLogin 去登录
         */
        goLogin() {
            let oldPage = this.$route.fullPath; // 点击登录时的页面
            window.sessionStorage.setItem('historyPage', JSON.stringify({ page: oldPage }));
            this.$router.push({ path: '/loginP' });
        },
        /**
         * @function goSignin 去注册
         */
        goSignin() {
            let oldPage = this.$route.fullPath; // 点击注册时的页面
            window.sessionStorage.setItem('historyPage', JSON.stringify({ page: oldPage }));
            this.$router.push({ path: '/signinP' });
        },
        /**
         * @function handleNavEnter 鼠标进入
         */
        handleNavEnter(i) {
            setTimeout(() => {
                if(this.historyHoverIndex != i) {
                    this.leftMenuList = [];
                    this.rightMenuList = [];
                    this.leftMenuIndex = 0;
                }
                if(i >= 3 && i <= 5) {
                    this.navHoverIndex = i;
                    this.historyHoverIndex = i;
                    this.$axios.get(this.$urls.columnCateList, {
                        params: {
                            column_id: this.navList[i].id
                        }
                    }).then(res => {
                        // console.log('catelist:', res);
                        let data = res.result;
                        this.leftMenuList = data;
                        let list = this.leftMenuList[this.leftMenuIndex].son;
                        this.rightMenuList = list && list.length > 0 ? list : [];
                        this.$store.commit('setGoodsCateList', data);
                    });
                    this.pullDownMenuShow = true;
                    document.getElementById('pullDownMenu').addEventListener('mouseenter', this.listenPullDownMenu);
                }
            }, 0);
        },
        /**
         * @function handleNavLeave 鼠标离开
         */
        handleNavLeave() {
            setTimeout(() => {
                if(!this.pullDownMenuEnter) {
                    this.navHoverIndex = -1;
                    setTimeout(() => {
                        if(this.navHoverIndex < 3 || this.navHoverIndex > 5) {
                            this.pullDownMenuShow = false;
                        }
                    }, 0);
                }
            }, 0);
        },
        /**
         * @function handleNavClick 导航点击
         * @param { number } i 点击项
         */
        handleNavClick(i) {
            this.navIndex = i;
            this.$store.commit('setPageModuleList', this.navList[i].children);
            let path = '';
            switch (i) {
                case 0: // 首页
                    path = '/homeP';
                    break;
                case 1: // 快捷套餐
                    path = '/quickSetMealP';
                    break;
                case 2: // 严选商城
                    path = '/strictlySelectedMallP';
                    break;
                case 3: // 企业应用
                    path = '/companyApplicationP';
                    this.pullDownMenuShow = false;
                    break;
                case 4: // 开发者
                    path = '/developerP';
                    this.pullDownMenuShow = false;
                    break;
                case 5: // 解决方案
                    path = '/solutionP';
                    this.pullDownMenuShow = false;
                    break;
                case 6: // 政策扶持
                    path = '/policiesSupportP';
                    break;
                case 7: // 伙伴计划
                    path = '/partnerPlanP';
                    break;
                default:
                    break;
            }
            if(path) {
                this.$router.push({ path: path });
            }
            this.setPageParams();
        },
        /**
         * @function listenPullDownMenu 监听鼠标进入/离开下拉菜单区域
         */
        listenPullDownMenu() {
            this.pullDownMenuEnter = true;
            document.getElementById('pullDownMenu').addEventListener('mouseleave', () => {
                this.pullDownMenuShow = this.pullDownMenuEnter = false;
                this.navHoverIndex = -1;
                document.getElementById('pullDownMenu').removeEventListener('mouseenter', this.listenPullDownMenu);
            });
        },
        /**
         * @function handleLeftMenuClick 左侧菜单点击
         */
        handleLeftMenuClick(i) {
            this.leftMenuIndex = i;
            let list = this.leftMenuList[i].son;
            this.rightMenuList = list && list.length > 0 ? list : [];
            this.$router.push({ path: '/companyProductListP', query: { 
                goods_cate_id: this.leftMenuList[i].id, 
                nav_active: this.navHoverIndex,
                cate_name: this.leftMenuList[i].name
            } });
            // this.pullDownMenuShow = false;
        },
        /**
         * @function handleRightMenuClick 右侧菜单点击
         */
        handleRightMenuClick(i, j) {
            let query = {};
            if(j > -1) {
                let navActive = 0;
                for(let idx = 0; idx < this.navList.length; idx++) {
                    let nav_item = this.navList[idx], r_menu = this.rightMenuList[i];
                    if(nav_item.id == r_menu.column_id) {
                        navActive = idx;
                        let pathList = ['/homeP', '/quickSetMealP', '/strictlySelectedMallP', '/companyApplicationP', 'developerP', '/solutionP', '/policiesSupportP', '/partnerPlanP'];
                        let obj = {
                            path: pathList[idx],
                            name: nav_item.name
                        };
                        window.sessionStorage.setItem('goodsCateGoodsList', JSON.stringify(obj));
                        let son = r_menu.son ? r_menu.son : [];
                        if(son.length > 0) {
                            query['nav_active'] = navActive;
                            query['goods_cate_id'] = son[j].id;
                            query['cate_name'] = son[j].name;
                        }
                    }
                }
            } else {
                let navActive = 0;
                this.navList.forEach((el, idx) => {
                    if(el.id == this.rightMenuList[i].column_id) {
                        navActive = idx;
                        let pathList = ['/homeP', '/quickSetMealP', '/strictlySelectedMallP', '/companyApplicationP', 'developerP', '/solutionP', '/policiesSupportP', '/partnerPlanP'];
                        let obj = {
                            path: pathList[idx],
                            name: el.name
                        };
                        window.sessionStorage.setItem('goodsCateGoodsList', JSON.stringify(obj));
                    }
                });
                query['nav_active'] = navActive;
                query['goods_cate_id'] = this.rightMenuList[i].id;
                query['cate_name'] = this.rightMenuList[i].name;
            }
            this.$router.push({ path: '/companyProductListP', query: query });
            this.pullDownMenuShow = false;
        },
        /**
         * @function setPageParams 设置页面缓存参数
         */
        setPageParams() {
            let data = {
                nav_index: this.navIndex
            };
            window.sessionStorage.setItem('pcHeader', JSON.stringify(data));
        }
    }
}
</script>
<style lang="scss" scoped>
@import './PcHeader.scss';
</style>
<style lang="scss">
.userdropdown {
    width: 166px;
    background: #112741;
    border-color: #112741;
    .popper__arrow, .popper__arrow::after {
        border-bottom-color: #112741 !important;
    }
    .el-dropdown-menu__item {
        color: rgba(255, 255, 255, .8);
        &:hover {
            background: none !important;
            color: #fff;
        }
    }
    .el-dropdown-menu__item--divided {
        border-top-color: rgba(255, 255, 255, .5);
    }
    .el-dropdown-menu__item--divided:before {
        background: none;
    }
}
.pc-header-container {
}
</style>


// WEBPACK FOOTER //
// src/components/pc/common/header/PcHeader.vue